import { render, staticRenderFns } from "./HeaderNavigationButton.vue?vue&type=template&id=4678e9b5&scoped=true&"
import script from "./HeaderNavigationButton.vue?vue&type=script&lang=ts&"
export * from "./HeaderNavigationButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4678e9b5",
  null
  
)

export default component.exports